module.exports = __webpack_public_path__ + "volkswagen.3996ef99efbe79611616.png";